<template>
  <div style="display: flex; flex-direction: column">
    <div class="query-bar">
      <el-select-tree
        v-model="query.deptID"
        url="SystemApplication/Dept/DeptTree"
        node-key="fDeptID"
        panel-width="300px"
        clearable
        size="small"
      />
      <el-select
        v-model="query.fType"
        placeholder="用户类型"
        style="width: 150px"
        size="small"
        clearable
      >
        <el-option value="普通用户" />
        <el-option value="管理员">管理员</el-option>
      </el-select>
      <el-select
        v-model="query.fState"
        placeholder="用户状态"
        style="width: 100px"
        size="small"
        clearable
      >
        <el-option value="正常">正常</el-option>
        <el-option value="禁用">禁用</el-option>
      </el-select>
      <el-input
        v-model="query.userName"
        placeholder="用户名"
        size="small"
        style="width: 200px"
        clearable
      />
      <el-input
        v-model="query.fName"
        placeholder="中文名"
        size="small"
        style="width: 200px"
        clearable
      />
      <el-input
        v-model="query.fNumber"
        placeholder="员工编号"
        size="small"
        style="width: 200px"
        clearable
      />
      <el-button type="primary" size="small" @click="refresh">查询</el-button>
      <el-button
        v-if="canAdd"
        type="primary"
        size="small"
        @click="_modify(null)"
        >新增</el-button
      >
    </div>
    <div style="flex: auto; display: flex; flex-direction: column">
      <el-table
        v-loading="loading"
        v-el-table-height-fix
        :data="tableData"
        height="100%"
      >
        <el-table-column prop="fNumber" label="员工编号" />
        <el-table-column prop="userName" label="用户名" />
        <el-table-column prop="fName" label="中文名" />
        <el-table-column prop="deptName" label="部门" />
        <el-table-column
          prop="hireDate"
          label="到职日期"
          :formatter="dateFormat"
        />
        <el-table-column prop="fType" label="用户类型" />
        <el-table-column prop="fState" label="用户状态" />
        <el-table-column label="操作" class-name="table-oper-col">
          <template slot-scope="scope">
            <template>
              <el-button type="text" size="small" @click="_modify(scope.row)"
                >查看</el-button
              >
            </template>
            <template>
              <ConfirmButton v-if="canDel" @confirm="_delete(scope.row)"
                >删除</ConfirmButton
              >
            </template>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div>
      <el-pagination
        :current-page.sync="query.pageIndex"
        :page-size.sync="query.pageSize"
        :page-sizes="[20, 50, 100, 500]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="this.pageRecordTotal"
        @size-change="refresh"
        @current-change="refresh"
      />
    </div>
  </div>
</template>
<script>
import moment from "moment";
import EditForm from "./EditForm";
import ConfirmButton from "@components/ConfirmButton";

export default {
  components: {
    EditForm,
    ConfirmButton,
  },
  data() {
    return {
      query: {
        userName: null,
        deptID: null,
        fName: null,
        fNumber: null,
        fType: null,
        fState: null,

        pageIndex: 1,
        pageSize: 20,
      },
      pageRecordTotal: 0,

      tableData: [],
      loading: false,
      currentEditItem: null,
      canAdd: true,
      canEdit: true,
      canDel: true,
    };
  },
  mounted() {
    this.refresh();

    //  根据权限设置编辑功能
    const userGrants = this.$store.state.userInfo.userGrants;
    // console.log(userGrants,'userGrants')
    userGrants.forEach((val) => {
      if (val.key == "001004002") {
        this.canAdd = val.isGrant;
      }
      if (val.key == "001004003") {
        this.canEdit = val.isGrant;
      }
      if (val.key == "001004004") {
        this.canDel = val.isGrant;
      }
    });
  },
  methods: {
    refresh() {
      this.loading = true;
      this.$httpPost("SystemApplication/User/UserEntry", this.query)
        .then((res) => {
          if (!res.isSuccess) {
            this.$message.error(res.message);
            return;
          }
          this.tableData = res.datalist.dataEntry;
          this.pageRecordTotal = res.datalist.total;
        })
        .finally(() => (this.loading = false));
    },

    _modify: async function (row) {
      const isNew = !row;
      if (isNew) {
        this.currentEditItem = {
          userName: await this.getUserName(),
          fPassword: null,
          fType: "普通用户",
          fState: "正常",
          fConcurrent: false,
          fNumber: null,
          fName: null,
          pictureUrl: null,
          fEnglishName: null,
          fIsRegionAssistant: false,
          fDeptId: null,
          fRegionID: null,
          fGender: "女",
          fBirthday: null,
          fTitleID: null,
          fIdentityCard: null,
          fHomePhone: null,
          fMobilePhone: null,
          fCompanyEmail: null,
          fEmail: null,
          fExtension: null,
          fHireDate: null,
          fDes: null,
          roles: [],
        };
      } else {
        this.currentEditItem = await this.$httpPost(
          "SystemApplication/User/GetUser",
          { fid: row.userID }
        ).then((res) => res.datalist);
      }
      let or;
      if (isNew) {
        or = this.canAdd;
      } else {
        or = this.canEdit;
      }
      const h = this.$createElement;
      this.$formDlg({
        title: isNew ? "新建用户" : `查看用户`,
        formTpl: <EditForm form={this.currentEditItem}></EditForm>,
        formSubmit: (formData) => this.postData(isNew, formData),
        width: "90%",
        readonly: !or,
      });
    },
    _delete(row) {
      this.delUser(row.userID);
    },
    postData(isNew, data) {
      return this.$httpPostFile2(
        `SystemApplication/User/${isNew ? "Add" : "Modify"}User`,
        {
          datalist: JSON.stringify(data.data),
        },
        { file: data.file }
      ).then(async (res) => {
        if (res.isSuccess) {
          this.$message.success(res.message);
          this.refresh();
        } else {
          if (res.returnCode == "00009") {
            this.currentEditItem.userName = await this.getUserName(); // 刷新用户名
          }
          this.$message.error(res.message);
          throw res.message;
        }
      });
    },
    delUser(userId) {
      return this.$httpPost(`SystemApplication/User/DeleteUser`, {
        fid: userId,
      }).then((res) => {
        if (res.isSuccess) {
          this.$message.success(res.message);
          this.refresh();
        } else {
          this.$message.error(res.message);
          throw res.message;
        }
      });
    },
    getUserName: function () {
      return this.$httpPost("SystemApplication/User/MaxUserName").then(
        (res) => res.datalist
      );
    },
    dateFormat: function (row, column, cellValue) {
      var date = cellValue;
      if (date == undefined) {
        return "";
      }
      return moment(date).format("YYYY-MM-DD");
    },
  },
};
</script>
